function isNumber(input: any): boolean {
  return typeof input === 'number' && input === input
}

export default isNumber
